import React, { Component } from 'react';
import { Row, Col } from 'reactstrap';
import backarrow from '.././images/backarrow.png';

export default class SecondaryNav extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div>
                <Row>
                    <Col sm="12">
                        <p className="backButton" onClick={this.props.onClickBack}>
                            <img src={backarrow} height="20" width="20" />
                            {this.props.navTitle}
                        </p>
                    </Col>
                </Row>                
            </div>
        )
    }
}